// 分類列表 - 標題 banner
import Image from 'next/image';
import ClassificationList from './ClassificationList'; // 大分類按鈕
import CategoryTags from './CategoryTags'; // 標籤列

import styles from '../../app/[locale]/page.module.scss';
import { DEFAULT_LIST_BG } from '@/common/constant';

const TitleBanner = ({ t, type, background, tags }) => {
    return (
        <div className="relative [&>div]:relative [&>div]:z-[2]">
            {/* 分類標題 */}
            <div className="pl-[30px] py-[18px] flex items-center gap-x-[8px] text-h1 ulg:px-[15px] ulg:pt-[25px]">
                <p className="text-white">{t('TITLE_ALLNEWS')}</p>
                <p style={{ fontFamily: 'auto' }} className={styles.stroke}>
                    NEWS
                </p>
            </div>

            {/* 大分類按鈕 */}
            <ClassificationList initType={type} />

            {/* 標籤列 */}
            <CategoryTags tags={tags} />

            {/* 背景圖 */}
            <Image
                loading="eager"
                className="gtm-banner-H03 absolute z-[0] bottom-0 left-0 w-full h-[calc(100%+54px)] object-cover object-center"
                width={1240}
                height={233}
                src={background?.img || DEFAULT_LIST_BG}
                alt={background?.alt || 'background'}
                sizes="50vw"
            />

            {/* 遮罩 */}
            <div className="!absolute !z-[1] bottom-0 left-0 w-full h-[calc(100%+54px)] bg-[#141414] bg-opacity-[.6]" />
        </div>
    );
};

export default TitleBanner;
